<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col offset-md="1" offset-lg="2">
        <Container :paddedTopBottom="false">
          <h2>Loïs Boersma</h2>
          <p>
            Mijn naam is Loïs Boersma en ik ben osteopaat bij Osteo's in Berkel
            en Rodenrijs. Al vanaf jonge leeftijd ben ik geïnteresseerd in het
            menselijk lichaam, beweging en sport. In 2015 studeerde ik af als
            fysiotherapeute aan de Hogeschool van Rotterdam. Ook na de opleiding
            bleef ik mij verdiepen door middel van cursussen en opleidingen op
            zoek naar de beste behandeling voor mijn cliënten. In mijn
            behandeling betrok ik wel steeds meer leefstijl-componenten maar ik
            miste essentiële kennis om mijn cliënten te helpen zoals ik dat het
            liefste wilde doen. De oplossing vond ik uiteindelijk in de aanpak
            van de osteopaat. Hierin kwamen alle relaties van het lichaam samen.
            De puzzelstukjes vielen op hun plek en ik vond de holistische aanpak
            die leidde tot betere en duurzamere resultaten.
          </p>
          <p>
            Na mijn masterstudie aan The International Academy of Osteopathy
            (IAO) in Zeist kreeg ik alle kans deze kennis toe te passen in dit
            mooie vak als osteopaat. Uitgeleerd ben ik nooit en nog altijd
            probeer ik mijn behandelingen elke dag een stukje beter te maken
            door steeds te blijven leren. Dat doe ik door cursussen te blijven
            volgen en zo mijn kennis als osteopaat steeds te verdiepen. Ik help
            u graag naar een betere gezondheid!
          </p>
          <img src="../../assets/team/lois.jpg" alt="Lois" />
        </Container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Container from "../../components/Container.vue";
export default {
  name: "Lois",
  components: { Container }
};
</script>

<style lang="less" scoped>
h2 {
  font-size: 2rem;
  text-transform: uppercase;
  margin-bottom: 1rem;
  margin-top: 3rem;
}

h3 {
  font-size: 1.4rem;
  text-transform: uppercase;
  margin-bottom: 0.2rem;
  color: #747769;
  em {
    font-style: normal;
    color: #747769;
  }
}

img {
  max-width: 100%;
}
</style>
